import siteConfig from "./config";
import autocomplete from "./extensions/autocomplete";

let DEBUG = false;

$(function () {
    let site = new siteConfig(), conf;

    site != undefined ? conf = site : conf = 0;
    if (conf) {
        conf.configureVideos();
        conf.initSearch();
        conf.fillPaginatateIndex(1);
        conf.setSearchResultText();
        conf.resizeIFrames("#main iframe.video-embed-item");
        conf.disableIOSCalender();

        /* config news Detail i backlink is active */
        if(document.querySelector(".frame-type-news_newsdetail .news-backlink-wrap")) {
            conf.newsDetail();
        }
    }

    DEBUG ? console.debug("conf: ", site) : "";

    /* news text change */
    try {
        document.querySelector(".news .news-backlink-wrap a").innerText = "Zurück zu den Ergebnissen";
    } catch (error) {
        if (DEBUG) {
            console.log("Error at news text change: ", error);
        }
    }
});

// close filter popup on click outside
document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
        document.querySelectorAll(".filter-popup.popup").forEach(popup => {
            const content = popup.querySelector(".popup-content");

            const isOpen = !popup.classList.contains("hidden");

            if (!isOpen) return;

            if (content.contains(e.target)) return;

            const justOpened = popup.dataset.justOpened === "true";
            if (justOpened) {
                popup.dataset.justOpened = "false";
                return;
            }

            popup.classList.add("hidden");
            if (document.querySelector("body").classList.contains("overflow-hidden")) {
                document.querySelector("body").classList.remove("overflow-hidden");
            }
        });
    });

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class"
            ) {
                const popup = mutation.target;
                const isNowOpen = !popup.classList.contains("hidden");
                if (isNowOpen) {
                    popup.dataset.justOpened = "true";
                    setTimeout(() => {
                        popup.dataset.justOpened = "false";
                    }, 100);
                }
            }
        });
    });

    document.querySelectorAll(".filter-popup.popup").forEach(popup => {
        observer.observe(popup, { attributes: true });
    });
    autocomplete();
    window.addEventListener('load', function () {
        const searchField = document.querySelector('.searchfield.fullscreen');
        const header = document.querySelector('#header');
        if (searchField && header) {
            const classobserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        if (!searchField.classList.contains('hidden')) {
                            header.style.zIndex = '999';
                        } else {
                            header.style.zIndex = '';
                        }
                    }
                });
            });

            classobserver.observe(searchField, { attributes: true, attributeFilter: ['class'] });
        }
    });
});



